import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer";
import { useAuth } from "../../context/auth";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/digitalparag/DigirtalParag.png"; // Ensure the logo path is correct
import { LogOut } from "lucide-react";

const IncometaxCalculation = () => {
  const EmpId = useParams().id;
  const navigate = useNavigate();
  const [gpfValue, setGpfValue] = useState("Yes"); // State to track GPF selection
  const [hraValue, setHraValue] = useState(0.09);
  const [selectIncreament, setSelectIncreament] = useState("July");
  // Use authentication context
  const [auth, setAuth] = useAuth();
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");

  useEffect(() => {
    if (userId === null || userId === "") {
      navigate("/sign_in");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("auth"); // Clear auth from localStorage
    localStorage.removeItem("userId"); // Clear auth from localStorage
    localStorage.removeItem("userName"); // Clear auth from localStorage
    localStorage.removeItem("userEmail"); // Clear auth from localStorage
    navigate("/");
  };

  const months = [
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Other",
  ];

  const columns = [
    "Basic",
    "DA",
    "HRA",
    "TA",
    "Fix TA",
    "WA",
    "CLA",
    "NPS",
    "BasicArrs",
    "DAArrs",
    "TotalPay",
    "GPF",
    "GPFInst",
    "NPS",
    "DCPS",
    "PT",
    "GIS",
    "LIC",
    "I.Tax",
  ];

  const [monthValues, setMonthValues] = useState(
    months.reduce((acc, month) => {
      acc[month] = columns.reduce((colAcc, col) => {
        colAcc[col] = 0;
        return colAcc;
      }, {});
      return acc;
    }, {})
  );

  const [selectedMonths, setSelectedMonths] = useState(
    months.reduce((acc, month) => {
      acc[month] = false;
      return acc;
    }, {})
  );

  const [calculatedValues, setCalculatedValues] = useState({
    grossSalary: 0,
    otherIncome: 0,
    totalIncome: 0,
    standardDeductionOld: 50000,
    standardDeductionNew: 75000,
    ptax: 0,
    homeLoanInterest: 0,
    hraExemption: 0,
    gpf: 0,
    gpfinst: 0,
    dcps: 0,
    gis: 0,
    lic: 0,
    tutionFees: 0,
    nsc: 0,
    pliRd: 0,
    homeLoanPrincipal: 0,
    mutualFund: 0,
    totalDeduction80C: 0,
    ccd1b: 0,
    ccd2: 0,
    mediclaim: 0,
    dependentHandicapped: 0,
    educationLoanInterest: 0,
    electricVehicleLoan: 0,
    donation: 0,
    selfHandicapped: 0,
    totalDeductionVIA: 0,
  });

  const [selectedLastMonths, setSelectedLastMonths] = useState("March");

  const handleMonthSelect = (month) => {
    const months = [
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
      "Jan",
      "Feb",
      "Other",
    ];

    const referenceMonth = "March";

    setSelectedMonths((prevSelectedMonths) => {
      const isSelecting = !prevSelectedMonths[month]; // Toggle the selection

      setMonthValues((prevValues) => {
        const updatedValues = { ...prevValues };

        if (isSelecting) {
          const currentIndex = months.indexOf(month);

          // Special handling for July and January
          if (
            selectIncreament === "July" &&
            month === "July" &&
            prevValues["June"]
          ) {
            const juneValues = prevValues["June"];
            if (gpfValue === "No") {
              let basicValue =
                Math.round(
                  (parseInt(juneValues["Basic"]) +
                    parseInt(juneValues["Basic"]) * 0.03) /
                    100
                ) * 100; // Rounds up to the nearest 100
              let daValue = Math.ceil(parseInt(basicValue * 50) / 100);
              updatedValues["July"] = {
                ...juneValues,
                Basic: basicValue,
                DA: daValue,
                HRA: Math.round(basicValue * hraValue),
                NPS: ((basicValue + daValue) * 14) / 100,
                DCPS: ((basicValue + daValue) * 10) / 100,
              };
            } else {
              let basicValue =
                Math.round(
                  (parseInt(juneValues["Basic"]) +
                    parseInt(juneValues["Basic"]) * 0.03) /
                    100
                ) * 100; // Rounds up to the nearest 100
              let daValue = Math.ceil(parseInt(basicValue * 50) / 100);
              updatedValues["July"] = {
                ...juneValues,
                Basic: basicValue,
                DA: daValue,
                HRA: Math.round(basicValue * hraValue),
                NPS: 0,
                DCPS: 0,
              };
            }
          } else if (
            selectIncreament === "Jan" &&
            month === "Jan" &&
            prevValues["Dec"]
          ) {
            const decValues = prevValues["Dec"];

            if (gpfValue === "No") {
              let basicValue =
                Math.round(
                  (parseInt(decValues["Basic"]) +
                    parseInt(decValues["Basic"]) * 0.03) /
                    100
                ) * 100; // Rounds up to the nearest 100
              let daValue = Math.ceil(parseInt(basicValue * 50) / 100);
              updatedValues["Jan"] = {
                ...decValues,
                Basic: basicValue,
                DA: daValue,
                HRA: Math.round(basicValue * hraValue),
                NPS: ((basicValue + daValue) * 14) / 100,
                DCPS: ((basicValue + daValue) * 10) / 100,
              };
            } else {
              let basicValue =
                Math.round(
                  (parseInt(decValues["Basic"]) +
                    parseInt(decValues["Basic"]) * 0.03) /
                    100
                ) * 100; // Rounds up to the nearest 100
              let daValue = Math.ceil(parseInt(basicValue * 50) / 100);
              updatedValues["Jan"] = {
                ...decValues,
                Basic: basicValue,
                DA: daValue,
                HRA: Math.round(basicValue * hraValue),
                NPS: 0,
                DCPS: 0,
              };
            }
          } else {
            let prevMonth = "";
            for (let i = currentIndex - 1; i >= 0; i--) {
              if (prevSelectedMonths[months[i]]) {
                prevMonth = months[i];
                break;
              }
            }

            if (prevMonth && prevValues[prevMonth]) {
              updatedValues[month] = { ...prevValues[prevMonth] };
            } else {
              const referenceLastRow = Array.isArray(prevValues[referenceMonth])
                ? prevValues[referenceMonth][
                    prevValues[referenceMonth].length - 1
                  ]
                : prevValues[referenceMonth];

              updatedValues[month] = { ...referenceLastRow };
            }
          }

          // Special handling for February
          if (month === "Feb") {
            const previousMonth = months[months.indexOf(month) - 1];
            if (
              prevValues[previousMonth] &&
              prevValues[previousMonth]["PT"] > 0
            ) {
              updatedValues[month]["PT"] = 300; // Update PT to 300 if previous month PT is 200
            }
          }

          // Recalculate TotalPay for the selected month
          updatedValues[month]["TotalPay"] = [
            "Basic",
            "DA",
            "HRA",
            "TA",
            "Fix TA",
            "WA",
            "CLA",
            "NPS",
            "BasicArrs",
            "DAArrs",
          ].reduce((sum, col) => {
            return sum + (parseFloat(updatedValues[month][col]) || 0);
          }, 0);
        } else {
          // Reset all values to zero for the deselected month
          updatedValues[month] = columns.reduce((resetObj, col) => {
            resetObj[col] = 0;
            return resetObj;
          }, {});

          // No need to recalculate TotalPay as it's already zero
        }

        return updatedValues;
      });

      return {
        ...prevSelectedMonths,
        [month]: isSelecting, // Update selection status
      };
    });

    setSelectedLastMonths(month);
  };

  const handleGpfChange = (newGpfValue) => {
    setGpfValue(newGpfValue); // Update the state of gpfValue

    setMonthValues((prevValues) => {
      const updatedValues = { ...prevValues };

      // Iterate over all months to update values
      Object.keys(updatedValues).forEach((month) => {
        const basicValue = parseFloat(updatedValues[month]["Basic"]) || 0;
        const daValue = parseFloat(updatedValues[month]["DA"]) || 0;

        // Reset NPS and DCPS values for current month
        if (newGpfValue === "Yes") {
          updatedValues[month]["NPS"] = 0;
          updatedValues[month]["DCPS"] = 0;
        } else {
          const sumBasicAndDA = ((basicValue + daValue) * 14) / 100;
          const sumBasicAndDADCPS = ((basicValue + daValue) * 10) / 100;
          updatedValues[month]["NPS"] = Math.round(sumBasicAndDA);
          updatedValues[month]["DCPS"] = Math.round(sumBasicAndDADCPS);
        }

        // Recalculate TotalPay for the current month only
        const totalPay = [
          "Basic",
          "DA",
          "HRA",
          "TA",
          "Fix TA",
          "WA",
          "CLA",
          "NPS",
          // "DCPS", // Ensure DCPS is included
          "BasicArrs",
          "DAArrs",
        ].reduce((total, col) => {
          return total + (parseFloat(updatedValues[month][col]) || 0);
        }, 0);

        // Round the TotalPay and store it with two decimal places
        updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100;
      });

      return updatedValues;
    });
  };

  const handleHRAChange = (newHRAValue) => {
    setHraValue(newHRAValue); // Update the state of HRA value
    setMonthValues((prevValues) => {
      const updatedValues = { ...prevValues };

      // Iterate over all months to update HRA values
      Object.keys(updatedValues).forEach((month) => {
        const basicValue = parseFloat(updatedValues[month]["Basic"]) || 0;

        // Calculate HRA based on the selected percentage
        const hraValues = Math.round(basicValue * newHRAValue);
        updatedValues[month]["HRA"] = Math.round(hraValues);

        // Recalculate TotalPay for the month
        const totalPay = [
          "Basic",
          "DA",
          "HRA",
          "TA",
          "Fix TA",
          "WA",
          "CLA",
          "NPS",
          "BasicArrs",
          "DAArrs",
        ].reduce((total, col) => {
          return total + (parseFloat(updatedValues[month][col]) || 0);
        }, 0);

        // Round TotalPay and store it
        updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100;
      });

      return updatedValues;
    });
  };

  // const handleInputChange = (month, column, value) => {
  //   setSelectedLastMonths(month);
  //   setMonthValues((prevValues) => {
  //     const updatedValues = {
  //       ...prevValues,
  //       [month]: {
  //         ...prevValues[month],
  //         [column]: value,
  //       },
  //     };
  //     // Get updated Basic and DA values
  //     const basicValue = parseFloat(updatedValues[month]["Basic"]) || 0;
  //     const daValue = parseFloat(updatedValues[month]["DA"]) || 0;

  //     if (gpfValue === "No") {
  //       // Calculate their sum
  //       const sumBasicAndDA = ((basicValue + daValue) * 14) / 100;
  //       const sumBasicAndDADCPS = ((basicValue + daValue) * 10) / 100;

  //       // Add the sumBasicAndDA value to the NPS column
  //       updatedValues[month]["NPS"] = Math.round(sumBasicAndDA);
  //       updatedValues[month]["DCPS"] = Math.round(sumBasicAndDADCPS);
  //       const totalPay = [
  //         "Basic",
  //         "DA",
  //         "HRA",
  //         "TA",
  //         "Fix TA",
  //         "WA",
  //         "CLA",
  //         "NPS",
  //         "BasicArrs",
  //         "DAArrs",
  //       ].reduce((total, col) => {
  //         console.log(total);

  //         return total + (parseFloat(updatedValues[month][col]) || 0);
  //       }, 0);

  //       // Round the totalPay and store it with two decimal places
  //       updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

  //       return updatedValues;
  //     } else {
  //       updatedValues[month]["NPS"] = Math.round(0);
  //       updatedValues[month]["DCPS"] = Math.round(0);
  //       const totalPay = [
  //         "Basic",
  //         "DA",
  //         "HRA",
  //         "TA",
  //         "Fix TA",
  //         "WA",
  //         "CLA",
  //         "NPS",
  //         "BasicArrs",
  //         "DAArrs",
  //       ].reduce((total, col) => {
  //         console.log(total);

  //         return total + (parseFloat(updatedValues[month][col]) || 0);
  //       }, 0);

  //       // Round the totalPay and store it with two decimal places
  //       updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

  //       return updatedValues;
  //     }
  //   });
  // };

  const handleInputChange = (month, column, value) => {
    setSelectedLastMonths(month);
    setMonthValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [month]: {
          ...prevValues[month],
          [column]: value,
        },
      };

      // Get updated Basic value
      const basicValue = parseFloat(updatedValues[month]["Basic"]) || 0;

      // Check if the updated column is HRA
      if (column === "HRA") {
        // If the column being edited is HRA, directly assign the user-provided value
        updatedValues[month]["HRA"] = parseFloat(value) || 0;
      } else {
        // Otherwise, calculate HRA as 9% of the Basic value
        updatedValues[month]["HRA"] = Math.round(basicValue * hraValue);
      }

      // Determine the DA percentage based on the month
      let daPercentage = 0;
      if (["March", "April", "May", "June"].includes(month)) {
        daPercentage = 46; // 46% for March to June
      } else if (
        ["July", "Aug", "Sept", "Oct", "Nov", "Dec", "Jan", "Feb"].includes(
          month
        )
      ) {
        daPercentage = 50; // 50% for July to February
      }

      // Allow DA to be editable but fallback to default calculation if empty
      let daValue = 0;
      // parseFloat(updatedValues[month]["DA"]) ||
      //   Math.round((basicValue * daPercentage) / 100);
      // updatedValues[month]["DA"] = daValue;

      // Check if the updated column is HRA
      if (column === "DA") {
        daValue = parseFloat(value);
        // If the column being edited is HRA, directly assign the user-provided value
        updatedValues[month]["DA"] = parseFloat(value) || 0;
      } else {
        daValue = Math.round((basicValue * daPercentage) / 100);
        // Otherwise, calculate HRA as 9% of the Basic value
        updatedValues[month]["DA"] = Math.round(
          (basicValue * daPercentage) / 100
        );
      }

      if (gpfValue === "No") {
        // Calculate their sum

        // const sumBasicAndDADCPS = ((basicValue + daValue) * 10) / 100;
        if (column === "NPS") {
          updatedValues[month]["NPS"] = parseFloat(value) || 0;
        } else if (column !== "DCPS") {
          const sumBasicAndDA = ((basicValue + daValue) * 14) / 100;
          updatedValues[month]["NPS"] = Math.round(sumBasicAndDA);
        }

        // const sumBasicAndDA = ((basicValue + daValue) * 14) / 100;
        if (column === "DCPS") {
          updatedValues[month]["DCPS"] = parseFloat(value) || 0;
        } else if (column !== "NPS") {
          const sumBasicAndDADCPS = ((basicValue + daValue) * 10) / 100;
          updatedValues[month]["DCPS"] = Math.round(sumBasicAndDADCPS);
        }

        // Allow NPS to be editable but fallback to default calculation if empty
        // updatedValues[month]["NPS"] =
        //   parseFloat(updatedValues[month]["NPS"]) || Math.round(sumBasicAndDA);

        // // Allow DCPS to be editable but fallback to default calculation if empty
        // updatedValues[month]["DCPS"] =
        //   parseFloat(updatedValues[month]["DCPS"]) ||
        //   Math.round(sumBasicAndDADCPS);

        const totalPay = [
          "Basic",
          "DA",
          "HRA",
          "TA",
          "Fix TA",
          "WA",
          "CLA",
          "NPS",
          "BasicArrs",
          "DAArrs",
        ].reduce((total, col) => {
          return total + (parseFloat(updatedValues[month][col]) || 0);
        }, 0);

        // Round the totalPay and store it with two decimal places
        updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

        return updatedValues;
      } else {
        updatedValues[month]["NPS"] =
          parseFloat(updatedValues[month]["NPS"]) || Math.round(0);
        updatedValues[month]["DCPS"] =
          parseFloat(updatedValues[month]["DCPS"]) || Math.round(0);

        const totalPay = [
          "Basic",
          "DA",
          "HRA",
          "TA",
          "Fix TA",
          "WA",
          "CLA",
          "NPS",
          "BasicArrs",
          "DAArrs",
        ].reduce((total, col) => {
          return total + (parseFloat(updatedValues[month][col]) || 0);
        }, 0);

        // Round the totalPay and store it with two decimal places
        updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

        return updatedValues;
      }
    });
  };

  // const handleInputChange = (month, column, value) => {
  //   setSelectedLastMonths(month);
  //   setMonthValues((prevValues) => {
  //     const updatedValues = {
  //       ...prevValues,
  //       [month]: {
  //         ...prevValues[month],
  //         [column]: value,
  //       },
  //     };

  //     // Get updated Basic value
  //     const basicValue = parseFloat(updatedValues[month]["Basic"]) || 0;
  //     // Calculate default HRA as 9% of Basic
  //     updatedValues[month]["HRA"] = Math.round(basicValue * 0.09); // HRA is 9% of Basic
  //     // Determine the DA percentage based on the month
  //     let daPercentage = 0;
  //     if (["March", "April", "May", "June"].includes(month)) {
  //       daPercentage = 46; // 46% for March to June
  //     } else if (
  //       ["July", "Aug", "Sept", "Oct", "Nov", "Dec", "Jan", "Feb"].includes(
  //         month
  //       )
  //     ) {
  //       daPercentage = 50; // 50% for July to February
  //     }

  //     // Calculate DA value based on Basic value and DA percentage
  //     const daValue = (basicValue * daPercentage) / 100;
  //     updatedValues[month]["DA"] = Math.round(daValue);

  //     if (gpfValue === "No") {
  //       // Calculate their sum
  //       const sumBasicAndDA = ((basicValue + daValue) * 14) / 100;
  //       const sumBasicAndDADCPS = ((basicValue + daValue) * 10) / 100;

  //       // Add the sumBasicAndDA value to the NPS column
  //       updatedValues[month]["NPS"] = Math.round(sumBasicAndDA);
  //       updatedValues[month]["DCPS"] = Math.round(sumBasicAndDADCPS);

  //       const totalPay = [
  //         "Basic",
  //         "DA",
  //         "HRA",
  //         "TA",
  //         "Fix TA",
  //         "WA",
  //         "CLA",
  //         "NPS",
  //         "BasicArrs",
  //         "DAArrs",
  //       ].reduce((total, col) => {
  //         return total + (parseFloat(updatedValues[month][col]) || 0);
  //       }, 0);

  //       // Round the totalPay and store it with two decimal places
  //       updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

  //       return updatedValues;
  //     } else {
  //       updatedValues[month]["NPS"] = Math.round(0);
  //       updatedValues[month]["DCPS"] = Math.round(0);

  //       const totalPay = [
  //         "Basic",
  //         "DA",
  //         "HRA",
  //         "TA",
  //         "Fix TA",
  //         "WA",
  //         "CLA",
  //         "NPS",
  //         "BasicArrs",
  //         "DAArrs",
  //       ].reduce((total, col) => {
  //         return total + (parseFloat(updatedValues[month][col]) || 0);
  //       }, 0);

  //       // Round the totalPay and store it with two decimal places
  //       updatedValues[month]["TotalPay"] = Math.round(totalPay * 100) / 100; // Rounds to nearest two decimal places

  //       return updatedValues;
  //     }
  //   });
  // };

  const calculateTotals = () => {
    return columns.map((column) =>
      months.reduce((total, month) => {
        const value = parseFloat(monthValues[month]?.[column]) || 0;
        return total + value;
      }, 0)
    );
  };

  const [wa, setWa] = useState(0);

  useEffect(() => {
    const totals = calculateTotals();
    setWa(totals[columns.indexOf("WA")] || 0);
    const grossSalary = totals[columns.indexOf("TotalPay")] || 0;
    const ptax = totals[columns.indexOf("PT")] || 0;
    const gpf = totals[columns.indexOf("GPF")] || 0;
    const gpfinst = totals[columns.indexOf("GPFInst")] || 0;
    const wa = totals[columns.indexOf("WA")] || 0;
    const dcps = totals[columns.indexOf("DCPS")] || 0;
    const gis = totals[columns.indexOf("GIS")] || 0;
    const lic = totals[columns.indexOf("LIC")] || 0;
    const nps = totals[columns.indexOf("NPS")] || 0;
    const itax = totals[columns.indexOf("I.Tax")] || 0; // Get the total I.Tax
    let dcps80C = 50000 < parseInt(dcps) ? parseInt(dcps) - 50000 : 0;
    let ccd1bs = 50000 < parseInt(dcps) ? 50000 : parseInt(dcps);
    setCalculatedValues((prev) => ({
      ...prev,
      grossSalary,
      ptax,
      wa,
      gpf,
      gpfinst,
      dcps,
      gis,
      lic,
      nps,
      itax, // Add this line to store the total I.Tax
      totalIncome: grossSalary + prev.otherIncome,
      totalDeduction80C:
        gpf +
        gpfinst +
        dcps80C +
        gis +
        lic +
        prev.tutionFees +
        prev.nsc +
        prev.pliRd +
        prev.homeLoanPrincipal +
        prev.mutualFund,

      totalDeductionVIA:
        ccd1bs +
        nps +
        prev.mediclaim +
        prev.dependentHandicapped +
        prev.educationLoanInterest +
        prev.electricVehicleLoan +
        prev.donation +
        prev.selfHandicapped,
    }));
  }, [monthValues]);

  const handleCalculatedValueChange = (field, value) => {
    setCalculatedValues((prev) => {
      const updatedValues = {
        ...prev,
        [field]: parseFloat(value),
      };
      let dcps =
        50000 < parseInt(updatedValues.dcps)
          ? parseInt(updatedValues.dcps) - 50000
          : 0;
      updatedValues.totalIncome =
        updatedValues.grossSalary + updatedValues.otherIncome;
      updatedValues.totalDeduction80C =
        updatedValues.gpf +
        updatedValues.gpfinst +
        updatedValues.dcps +
        updatedValues.gis +
        updatedValues.lic +
        updatedValues.tutionFees +
        updatedValues.nsc +
        updatedValues.pliRd +
        updatedValues.homeLoanPrincipal +
        updatedValues.mutualFund;
      let abc =
        50000 < parseInt(updatedValues.dcps)
          ? 50000
          : parseInt(updatedValues.dcps);
      updatedValues.totalDeductionVIA =
        abc +
        updatedValues.nps +
        updatedValues.mediclaim +
        updatedValues.dependentHandicapped +
        updatedValues.educationLoanInterest +
        updatedValues.electricVehicleLoan +
        updatedValues.donation +
        updatedValues.selfHandicapped;

      return updatedValues;
    });
  };

  const FormInput = React.memo(
    ({ label, value, onChange, readOnly, disabled }) => {
      return (
        <div className="flex justify-between items-center mb-1">
          <label
            className={
              label === "Total Income" ||
              label === "Old Regime Tax" ||
              label === "New Regime Tax" ||
              label === "Tax Deducted From SALARY Rs." ||
              label === "Net Income Tax to Pay Rs." ||
              label === "Total Income Tax PAYABLE Rs."
                ? "fw-bold text-basic"
                : label === "Deduction U/s 80-C" ||
                  label === "Total Deduction U/S VI-A"
                ? "fw-bold text-sm"
                : label === "Refund Tax Amount:"
                ? "fw-bold text-danger text-sm"
                : "text-sm"
            }
          >
            {label}{" "}
            {label === "Deduction U/s 80-C" ? (
              <small className="text-danger fw-bold">
                (limit upto 1.5 lacs)
              </small>
            ) : (
              ""
            )}
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)} // Properly calls the onChange handler
            // className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
            className={
              label === "Total Income" ||
              label === "Old Regime Tax" ||
              label === "New Regime Tax" ||
              label === "Tax Deducted From SALARY Rs." ||
              label === "Net Income Tax to Pay Rs." ||
              label === "Deduction U/s 80-C" ||
              label === "Total Deduction U/S VI-A" ||
              label === "Total Income Tax PAYABLE Rs." ||
              label === "Refund Tax Amount:"
                ? "fw-bold border rounded px-3 py-1 w-32 sm:w-32 text-right"
                : "border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
            }
            readOnly={readOnly}
            disabled={disabled}
          />
        </div>
      );
    }
  );

  const FormSection = React.memo(({ title, children }) => (
    <div className="bg-blue-50 p-4 rounded-lg mb-6 text-left">
      <h5 className="font-bold mb-3" style={{ fontSize: "18px" }}>
        {title}
      </h5>
      {children}
    </div>
  ));

  const taxItems = [];

  const [totalTaxPayable, setTotalTaxPayable] = useState(0);
  const [oldRegimeData, setOldRegimeData] = useState(null);
  const [newRegimeData, setNewRegimeData] = useState(null);

  const calculateRegimeData = async (
    title,
    taxableIncomeMain,
    regimeTax,
    rebate87A,
    educationCess,
    totalTaxPayable,
    taxDeductedFromSalary,
    netIncomeTaxToPay
  ) => {
    const regimeData = {
      [`${title.toLowerCase().replace(" ", "_")}_taxable_income`]:
        taxableIncomeMain,
      [`${title.toLowerCase().replace(" ", "_")}_tax`]: Math.round(regimeTax),
      rebate: Math.round(rebate87A * 100) / 100,
      education_cess: Math.round(educationCess),
      total_it_payable: Math.round(totalTaxPayable),
      deducted_salary: taxDeductedFromSalary,
      net_it_pay: Math.ceil(netIncomeTaxToPay / 10) * 10,
    };

    if (title === "Old Regime") {
      setOldRegimeData(regimeData);
    } else if (title === "New Regime") {
      setNewRegimeData(regimeData);
    }
  };

  const RegimeSection = ({ title, items, taxableIncome, tax }) => {
    // Calculate rebate under Section 87A based on the title (Old/New Regime)
    let rebate87A = 0;

    let taxableIncomeMain = 0;

    let regimeTax = 0;

    const itax = calculatedValues.itax; // Get the total I.Tax from calculated values

    // Determine rebate under Section 87A
    if (title === "Old Regime") {
      let hli =
        200000 < parseInt(calculatedValues.homeLoanInterest)
          ? parseInt(200000)
          : parseInt(calculatedValues.homeLoanInterest);
      taxableIncomeMain =
        taxableIncome -
        parseInt(calculatedValues.standardDeductionOld) -
        parseInt(calculatedValues.ptax) -
        hli;
      // taxableIncomeMain =
      //   taxableIncome -
      //   calculatedValues.standardDeductionOld -
      //   calculatedValues.ptax -
      //   calculatedValues.homeLoanInterest;
      regimeTax = calculateOldRegimeTax(taxableIncomeMain);
      if (taxableIncome <= 500000) {
        rebate87A = Math.min(tax, 12500); // Full rebate if tax <= 12500
      } else {
        rebate87A = 0; // No rebate for income above ₹5,00,000
      }
    } else if (title === "New Regime") {
      // alert(taxableIncome)
      taxableIncomeMain = taxableIncome;
      regimeTax = calculateNewRegimeTax(taxableIncomeMain);
      if (taxableIncome <= 750000) {
        rebate87A = Math.min(tax, 25000); // Full rebate if tax <= 25000
      } else {
        rebate87A = 0; // No rebate for income above ₹7,00,000
      }
    }

    // Calculate Education Cess @ 4%
    let educationCess = 0;
    // if (title === "Old Regime" && regimeTax >= 12500) {
    //   educationCess = regimeTax * 0.04; // 4% of the tax if tax >= 12500
    // } else if (title === "New Regime" && regimeTax >= 25000) {
    educationCess = regimeTax * 0.04; // 4% of the tax if tax >= 25000
    // }

    // Calculate Total Income Tax PAYABLE
    // let totalTaxPayable = tax + educationCess; // Tax + Education Cess

    let totalTaxPayable = 0; // Tax + Education Cess
    // Tax Deducted From SALARY is equal to the calculated tax for the respective regime
    const taxDeductedFromSalary = itax; // Use I.Tax total
    // Calculate Net Income Tax to Pay
    // title === "New Regime" && regimeTax < 25000
    //   ? (totalTaxPayable = 0)
    //   : title === "Old Regime" && regimeTax < 12500
    //   ? (totalTaxPayable = 0)
    //   : (
    totalTaxPayable = regimeTax + educationCess;
    let netIncomeTaxToPay = totalTaxPayable - taxDeductedFromSalary;
    // Total Income Tax PAYABLE - Tax Deducted From SALARY
    // const lowValue = Math.min(65349, 84061); // Get the lower value
    // setTotalTaxPayable(lowValue); // Update the state with the lower value
    setTimeout(() => {
      calculateRegimeData(
        title,
        taxableIncomeMain,
        regimeTax,
        rebate87A,
        educationCess,
        totalTaxPayable,
        taxDeductedFromSalary,
        netIncomeTaxToPay
      );
    }, 0);
    setTotalTaxPayable(totalTaxPayable);

    return (
      <div className="w-full pr-6 mb-6 md:mb-0 ">
        <h2 className="font-bold text-lg text-left mb-4">{title}</h2>

        {/* Render FormInput for Taxable Income and Tax */}
        <FormInput
          label={`${title} Taxable Income`}
          value={taxableIncomeMain < 0 ? 0 : taxableIncomeMain}
          readOnly
        />
        <FormInput
          label={`${title} Tax`}
          value={Math.round(regimeTax)}
          readOnly
        />
        {/* Math.round(tax * 100) / 100 */}
        {/* Render FormInput for Rebate Under Section 87A */}
        <FormInput
          label="Rebate Under Section 87A"
          value={Math.round(rebate87A)}
          readOnly
        />

        {/* Render FormInput for Education Cess */}
        <FormInput
          label="Education Cess @ 4%"
          value={Math.round(educationCess)}
          readOnly
        />

        {/* Render FormInput for Total Income Tax PAYABLE */}
        <FormInput
          label="Total Income Tax PAYABLE Rs."
          value={Math.round(totalTaxPayable)}
          readOnly
        />
        {/* value={Math.round(totalTaxPayable * 100) / 100} */}

        {/* Render FormInput for Tax Deducted From SALARY */}
        <FormInput
          label="Tax Deducted From SALARY Rs."
          value={Math.max(
            Math.round(Math.ceil(taxDeductedFromSalary / 10) * 10),
            0
          )}
          readOnly
        />

        {/* Render FormInput for Net Income Tax to Pay */}
        <FormInput
          label="Net Income Tax to Pay Rs."
          value={Math.ceil(netIncomeTaxToPay / 10) * 10} // Updated calculation
          readOnly
        />

        <FormInput
          label="Refund Tax Amount:"
          value={
            totalTaxPayable < taxDeductedFromSalary
              ? Math.max(Math.round(totalTaxPayable - taxDeductedFromSalary))
              : 0
          } // Ensure value is at least 0
          readOnly
        />

        {/* Render other items */}
        {items.map((item, index) => (
          <FormInput key={index} label={item} />
        ))}
      </div>
    );
  };

  const calculateOldRegimeTax = (taxableIncome) => {
    let tax = 0;
    if (taxableIncome <= 250000) {
      tax = 0;
    } else if (taxableIncome > 250000 && taxableIncome <= 500000) {
      tax = (taxableIncome - 250000) * 0.05;
    } else if (taxableIncome > 500000 && taxableIncome <= 1000000) {
      tax = 250000 * 0.05 + (taxableIncome - 500000) * 0.2;
    } else {
      tax = 250000 * 0.05 + 500000 * 0.2 + (taxableIncome - 1000000) * 0.3;
    }
    return tax;
  };

  // const calculateNewRegimeTax = (taxableIncome) => {
  //   let tax = 0;
  //   if (taxableIncome <= 300000) {
  //     tax = 0;
  //   } else if (taxableIncome >= 300001 && taxableIncome <= 600000) {

  //     tax = (taxableIncome - 300000) * 0.05;

  //   } else if (taxableIncome >= 600001 && taxableIncome <= 900000) {

  //     tax = 300000 * 0.05 + (taxableIncome - 700000) * 0.1;

  //   } else if (taxableIncome >= 900001 && taxableIncome <= 1200000) {

  //     tax = 300000 * 0.05 + 300000 * 0.1 + (taxableIncome - 1000000) * 0.15;

  //   } else if (taxableIncome >= 1200001 && taxableIncome <= 1500000) {
  //     tax =
  //       300000 * 0.05 +
  //       300000 * 0.1 +
  //       300000 * 0.15 +
  //       (taxableIncome - 1200000) * 0.2;
  //   } else {
  //     tax =
  //       300000 * 0.05 +
  //       300000 * 0.1 +
  //       300000 * 0.15 +
  //       300000 * 0.2 +

  //       (taxableIncome - 1500000) * 0.3;
  //   }
  //   return tax;
  // };

  const calculateNewRegimeTax = (taxableIncome) => {
    let tax = 0;

    // No tax if income <= ₹3,00,000
    if (taxableIncome <= 300000) {
      tax = 0;

      // 5% tax for income ₹3,00,001 to ₹6,00,000
    } else if (taxableIncome > 300000 && taxableIncome <= 700000) {
      tax = (taxableIncome - 300000) * 0.05;

      // 10% tax for income ₹6,00,001 to ₹9,00,000
    } else if (taxableIncome > 700000 && taxableIncome <= 1000000) {
      tax = 400000 * 0.05 + (taxableIncome - 700000) * 0.1;

      // 15% tax for income ₹9,00,001 to ₹12,00,000
    } else if (taxableIncome > 1000000 && taxableIncome <= 1200000) {
      tax = 400000 * 0.05 + 300000 * 0.1 + (taxableIncome - 1000000) * 0.15;

      // 20% tax for income ₹12,00,001 to ₹15,00,000
    } else if (taxableIncome > 1200000 && taxableIncome <= 1500000) {
      tax =
        400000 * 0.05 +
        300000 * 0.1 +
        200000 * 0.15 +
        (taxableIncome - 1200000) * 0.2;

      // 30% tax for income above ₹15,00,000
    } else {
      tax =
        300000 * 0.05 +
        200000 * 0.1 +
        300000 * 0.15 +
        300000 * 0.2 +
        (taxableIncome - 1500000) * 0.3;
    }

    // Section 87A Rebate for income <= ₹7,00,000
    if (taxableIncome <= 700000) {
      tax = 0;
    }

    // Add Health & Education Cess (4%)

    return tax;
  };

  // const calculateNewRegimeTax = (taxableIncome) => {
  //   let tax = 0;
  //   if (taxableIncome <= 300000) {
  //     tax = 0;
  //   } else if (taxableIncome > 300000 && taxableIncome <= 700000) {

  //     tax = (taxableIncome - 300000) * 0.05;

  //   } else if (taxableIncome > 700000 && taxableIncome <= 1000000) {

  //     tax = 400000 * 0.05 + (taxableIncome - 700000) * 0.1;

  //   } else if (taxableIncome > 1000000 && taxableIncome <= 1200000) {

  //     tax = 400000 * 0.05 + 200000 * 0.1 + (taxableIncome - 1000000) * 0.15;

  //   } else if (taxableIncome > 1200000 && taxableIncome <= 1500000) {
  //     tax =
  //       400000 * 0.05 +
  //       200000 * 0.1 +
  //       300000 * 0.15 +
  //       (taxableIncome - 1200000) * 0.2;
  //   } else {
  //     tax =
  //       400000 * 0.05 +
  //       200000 * 0.1 +
  //       300000 * 0.15 +
  //       200000 * 0.2 +

  //       (taxableIncome - 1500000) * 0.3;
  //   }
  //   return tax;
  // };

  // else if (taxableIncome <= 1500000) {
  //   tax =
  //     300000 * 0.05 +
  //     300000 * 0.1 +
  //     300000 * 0.15 +
  //     300000 * 0.2 +
  //     (taxableIncome - 1250000) * 0.25;
  // }

  const calculateTaxableIncomeOldRegime = (
    grossSalary,
    totalDeduction80C,
    totalDeductionVIA,
    totalWA
  ) => {
    const deductionLimit80C = Math.min(totalDeduction80C, 150000);
    return grossSalary - (deductionLimit80C + totalDeductionVIA + totalWA);
  };

  const calculateTaxableIncomeNewRegime = (
    grossSalary,
    standardDeduction,
    totalDeductionVIA
  ) => {
    return grossSalary - standardDeduction - totalDeductionVIA;
  };

  useEffect(() => {
    const grossSalary = calculatedValues.totalIncome;
    const totalDeduction80C = calculatedValues.totalDeduction80C;
    const totalDeductionVIA = calculatedValues.totalDeductionVIA;
    const standardDeduction = calculatedValues.standardDeductionNew;

    const taxableIncomeOldRegime = calculateTaxableIncomeOldRegime(
      grossSalary,
      totalDeduction80C,
      totalDeductionVIA,
      calculatedValues.wa
    );
    const taxableIncomeNewRegime = calculateTaxableIncomeNewRegime(
      grossSalary,
      standardDeduction,
      calculatedValues.nps
    );

    const oldRegimeTax = calculateOldRegimeTax(taxableIncomeOldRegime);
    const newRegimeTax = calculateNewRegimeTax(taxableIncomeNewRegime);

    setCalculatedValues((prev) => ({
      ...prev,
      oldRegimeTaxableIncome: taxableIncomeOldRegime,
      oldRegimeTax,
      newRegimeTaxableIncome: taxableIncomeNewRegime,
      newRegimeTax,
    }));
  }, [
    calculatedValues.grossSalary,
    calculatedValues.totalDeduction80C,
    calculatedValues.totalDeductionVIA,
    calculatedValues.standardDeductionNew,
  ]);

  const [singleEmployee, setSingleEmployee] = useState(null);
  const [usersEmployee, setUsersEmployee] = useState([]);

  const getUsersEmployee = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-users-employee`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 201) {
        // setUsersEmployee(result.result);
        const data = result.result.find((item) => item._id === EmpId);
        setSingleEmployee(data || null);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getUsersEmployee();
  }, [userId]);

  // const getSingleEmployee = (e) => {
  //   const result = usersEmployee.find((item) => item._id === EmpId);
  //   setSingleEmployee(result || null);
  // };

  const storeITCData = async () => {
    const response = await fetch(
      `${api_url}/api/users/add-income-tax-calculation`,
      {
        method: "POST",
        body: JSON.stringify({
          monthValues,
          calculatedValues,
          singleEmployee,
          oldRegimeData,
          newRegimeData,
          userId,
          selectIncreament,
          hraValue,
          gpfValue,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();
    if (result.status === 201) {
      toast.success(result.message);
      setTimeout(() => {
        navigate("/dashboard/user_incometax_complete");
      }, 1000);
    } else {
      toast.error(result.message);
    }
  };

  const [ITCData, setITCData] = useState([]);
  const getITCData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-itc-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        setITCData(result.users);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getITCData();
  }, [EmpId]);

  useEffect(() => {
    let result = ITCData.find((item) => item.empId === EmpId);
    if (result) {
      alert("Already Work Completed");
      navigate("/dashboard/user_incometax");
    }
  }, [ITCData]);

  const handleCalculatedstandardDeductionNewChange = (field, value) => {
    setCalculatedValues((prevValues) => ({
      ...prevValues,
      standardDeductionNew: Number(value), // Update only the standardDeduction field
    }));
  };
  const handleCalculatedstandardDeductionOldChange = (field, value) => {
    setCalculatedValues((prevValues) => ({
      ...prevValues,
      standardDeductionOld: Number(value), // Update only the standardDeduction field
    }));
  };

  return (
    <>
      <header className="bg-gradient-to-r from-orange-400 via-white to-green-500 shadow-md w-full px-2 lg:px-3 h-16 flex items-center justify-between border-b border-gray-200">
        {/* Left section with Logo */}
        <div className="flex items-center space-x-4">
          <Link to="/dashboard/dashboard" className="flex items-center">
            <img
              src={logo}
              alt="Digital Parag Logo"
              className="h-12 sm:h-14 md:h-16"
            />
          </Link>
        </div>

        {/* Right side with user info and logout/login button */}
        <div className="flex items-center space-x-4">
          <Link to="/dashboard/dashboard" className="flex items-center fw-bold">
            Home
          </Link>
          {userName ? (
            <>
              <p className="text-black text-xs sm:text-sm md:text-base fw-bold">
                Hello, {userName}
              </p>
              <button
                className="text-yellow-200 hover:text-red-600 flex items-center"
                onClick={handleLogout}
              >
                <LogOut size={20} className="mr-1" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <Link
              to="/sign_in"
              className="text-gray-700 hover:text-blue-600 text-xs sm:text-sm md:text-base"
            >
              Login
            </Link>
          )}
        </div>
      </header>

      <div className="min-h-screen flex flex-col">
        <main className="flex-grow bg-gray-50 py-6">
          <div className="container mx-auto px-2">
            <div className="bg-white rounded-lg shadow-md p-4">
              <div className="mb-6 flex flex-col md:flex-row items-center justify-between">
                <div className="backButton">
                  <Link
                    to={"/dashboard/user_incometax"}
                    className="btn btn-secondary btn-sm"
                  >
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
                  </Link>
                </div>
                <div className="text-center flex-1">
                  <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">
                    Income Tax Calculation
                  </h1>
                  <h2 className="text-xl text-red-500 font-medium mt-2">
                    Monthly Statement showing Salary & Deduction Details
                  </h2>
                </div>
              </div>
              <div className="mb-5 text-start">
                <div className="row">
                  <div className="col-lg-3 col-4">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={singleEmployee && singleEmployee.EmpName}
                      readOnly
                    />
                    {/* <option value={""}>Select One</option>
                      {usersEmployee &&
                        usersEmployee.map((items) => (
                          <option value={items._id}>{items.EmpName}</option>
                        ))}
                    </select> */}
                  </div>
                  <div className="col-lg-3 col-4">
                    <label>Designation</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Designation"
                      value={singleEmployee && singleEmployee.EmpDesignation}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-2 col-4">
                    <label>Gender</label>
                    <input
                      type="text"
                      className="form-control"
                      value={singleEmployee && singleEmployee.gender}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-2 col-4">
                    <label>Pay Scale</label>
                    <input
                      type="text"
                      className="form-control "
                      value={singleEmployee && singleEmployee.payScale}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-2 col-4">
                    <label>
                      Increament Month<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      disabled={
                        calculatedValues.grossSalary === 0 ? false : true
                      }
                      onChange={(e) => setSelectIncreament(e.target.value)}
                    >
                      <option value={""}>Select One</option>
                      <option value={"No Increament"}>No Increament</option>
                      <option value={"July"}>July</option>
                      <option value={"Jan"}>Jan</option>
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3 col-4">
                    <label>Pan No.</label>
                    <input
                      type="text"
                      className="form-control uppercase"
                      placeholder="PAN No."
                      value={singleEmployee && singleEmployee.PANNo}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-4">
                    <label>Date of Birth</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Birth Date"
                      value={singleEmployee && singleEmployee.dateOfBirth}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-2 col-4">
                    <label>Adhar Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Aadhar No."
                      value={singleEmployee && singleEmployee.adharNo}
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-4 text-center">
                    <div className="flex flex-col md:flex-row md:w-auto md:ml-auto mt-2 md:mt-0 items-center">
                      <label className="text-gray-700 font-medium mr-4">
                        GPF<span className="text-danger">*</span> :
                      </label>
                      <div className="flex">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="gpf"
                            value="yes"
                            className="form-radio text-indigo-600"
                            checked={gpfValue === "Yes"}
                            onChange={() => handleGpfChange("Yes")}
                          />
                          <span className="ml-2">Yes</span>
                        </label>
                        <label className="inline-flex items-center ml-4">
                          <input
                            type="radio"
                            name="gpf"
                            value="no"
                            className="form-radio text-indigo-600"
                            onChange={() => handleGpfChange("No")}
                            checked={gpfValue === "No"}
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                    <div className="flex flex-col md:flex-row md:w-auto md:ml-auto mt-1 md:mt-0 items-center">
                      <label className="text-gray-700 font-medium mr-4">
                        HRA<span className="text-danger">*</span> :
                      </label>
                      <div className="flex">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="hra"
                            value="0.0"
                            className="form-radio text-indigo-600"
                            checked={hraValue === 0.0}
                            onChange={() => handleHRAChange(0)}
                          />
                          <span className="ml-2">0%</span>
                        </label>
                        <label className="inline-flex items-center ml-4">
                          <input
                            type="radio"
                            name="hra"
                            value="0.9"
                            className="form-radio text-indigo-600"
                            onChange={() => handleHRAChange(0.09)}
                            checked={hraValue === 0.09}
                          />
                          <span className="ml-2">9%</span>
                        </label>
                        <label className="inline-flex items-center ml-4">
                          <input
                            type="radio"
                            name="hra"
                            value="0.18"
                            className="form-radio text-indigo-600"
                            onChange={() => handleHRAChange(0.18)}
                            checked={hraValue === 0.18}
                          />
                          <span className="ml-2">18%</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="overflow-x-auto">
                <div className="min-w-[1000px]">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr>
                        <th className="sticky left-0 z-10 border border-gray-300 bg-gray-100 p-2">
                          MonthCopy
                        </th>
                        {columns.map((column, index) => (
                          <th
                            key={index}
                            className="border border-gray-300 bg-gray-100 p-2"
                          >
                            {column}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {months.map((month, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className={
                            rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="sticky left-0 z-10 border border-gray-300 p-2 text-blue-500 bg-inherit">
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={
                                  month === "March" || selectedMonths[month]
                                }
                                onChange={() => handleMonthSelect(month)}
                                className="form-checkbox"
                                disabled={month === "March"}
                              />
                              {month === "July" || month === "Jan" ? (
                                <span className="text-danger fw-bold">
                                  {month}
                                </span>
                              ) : (
                                <span disabled={month === "March"}>
                                  {month}
                                </span>
                              )}
                            </label>
                          </td>
                          {columns.map((column, colIndex) => (
                            <td
                              key={colIndex}
                              className="border border-gray-300 px-1 py-2"
                            >
                              <input
                                type="text"
                                className={
                                  column === "TotalPay"
                                    ? "fw-bold text-purple-800 w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                    : column === "Basic"
                                    ? "fw-bold  w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                    : "w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                }
                                value={
                                  monthValues[month]?.[column] !== undefined
                                    ? monthValues[month][column]
                                    : "0"
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    month,
                                    column,
                                    e.target.value
                                  )
                                }
                                disabled={
                                  (gpfValue === "Yes" &&
                                    (column === "NPS" || column === "DCPS")) || // Use OR here
                                  (gpfValue === "No" &&
                                    (column === "GPF" || column === "GPFInst")) // Use OR here
                                }
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                      <tr className="font-semibold bg-gray-100">
                        <td className="sticky left-0 z-10 border border-gray-300 p-2 text-red-500 bg-gray-100">
                          Total
                        </td>
                        {calculateTotals().map((total, index) => (
                          <td
                            key={index}
                            className="border border-gray-300 p-2 text-red-500 text-center"
                          >
                            {Math.round(total)}{" "}
                            {/* Rounding the total to the nearest whole number */}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/* Main section ends */}

        {/* Sub Section starts */}

        <div className="max-w-8xl mx-auto p-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <FormSection title="Income"> */}
            <div className="bg-blue-50 p-3 rounded-lg mb-6 text-left">
              <h5 className="font-bold mb-3" style={{ fontSize: 18 }}>
                Income
              </h5>
              <FormInput
                label="Gross Salary"
                value={calculatedValues.grossSalary}
                readOnly
              />
              <div className="d-flex justify-between my-1">
                <label>Other Income</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.otherIncome}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "otherIncome",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="Other Income"
                value={Math.round(calculatedValues.otherIncome * 100) / 100}
                onChange={(value) =>
                  handleCalculatedValueChange("otherIncome", value)
                }
                readOnly={false}
              /> */}

              <FormInput
                label="Total Income"
                value={Math.round(calculatedValues.totalIncome * 100) / 100}
                readOnly
              />
              <div className="mt-2">
                <h5 className="font-semibold mb-2" style={{ fontSize: "18px" }}>
                  Deduction
                </h5>
                {/* <FormInput
                  label="Standard Deduction"
                  value={
                    Math.round(calculatedValues.standardDeduction * 100) / 100
                  }
                  readOnly
                /> */}
                <div className="d-flex justify-between my-1">
                  <label>Standard Deduction(Old Regime)</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                    defaultValue={50000}
                    onChange={(value) =>
                      handleCalculatedstandardDeductionOldChange(
                        "standardDeductionOld",
                        value.target.value
                      )
                    }
                    readOnly
                  />
                </div>
                <div className="d-flex justify-between my-1">
                  <label>Standard Deduction(New Regime) </label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                    defaultValue={75000}
                    onChange={(value) =>
                      handleCalculatedstandardDeductionNewChange(
                        "standardDeductionNew",
                        value.target.value
                      )
                    }
                    readOnly
                  />
                </div>
                <FormInput
                  label="P.TAX"
                  value={Math.round(calculatedValues.ptax * 100) / 100}
                  readOnly
                />
                <FormInput label="WA" value={Math.round(wa)} readOnly />
              </div>
              <div className="mt-2">
                {/* <h3 className="font-semibold mb-2" style={{ fontSize: "18px" }}>
                  Home Loan
                </h3> */}
                <div className="d-flex justify-between">
                  <label>Home Loan Interest</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                    defaultValue={calculatedValues.homeLoanInterest}
                    onChange={(value) =>
                      handleCalculatedValueChange(
                        "homeLoanInterest",
                        value.target.value
                      )
                    }
                  />
                </div>
                <div className="d-flex justify-between mt-1">
                  <label>
                    Home Loan Interest{" "}
                    <small className="text-danger">(Eligible Amt.)</small>
                  </label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded fw-bold px-3 py-1 w-32 sm:w-32 text-right"
                    value={
                      200000 < parseInt(calculatedValues.homeLoanInterest)
                        ? 200000
                        : parseInt(calculatedValues.homeLoanInterest)
                    }
                    readOnly
                  />
                </div>
              </div>
              <div className="mt-2">
                <h3 className="font-semibold mb-2" style={{ fontSize: "18px" }}>
                  HRA Rent
                </h3>
                <div className="d-flex justify-between my-1">
                  <label>HRA Exemption</label>
                  <input
                    type="text"
                    className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                    defaultValue={calculatedValues.hraExemption}
                    onChange={(value) =>
                      handleCalculatedValueChange(
                        "hraExemption",
                        value.target.value
                      )
                    }
                  />
                </div>
                {/* <FormInput
                  label="HRA Exemption"
                  value={Math.round(calculatedValues.hraExemption * 100) / 100}
                  onChange={(value) =>
                    handleCalculatedValueChange("hraExemption", value)
                  }
                  readOnly={false}
                /> */}
              </div>
            </div>
            {/* </FormSection> */}

            <div className="bg-blue-50 p-3 rounded-lg mb-6 text-left">
              <h5 className="font-bold mb-3" style={{ fontSize: 18 }}>
                Deduction U/S 80-C
              </h5>
              {/* <FormSection title="Deduction U/S 80-C"> */}
              <FormInput
                label="GPF"
                value={Math.round(
                  calculatedValues.gpf + calculatedValues.gpfinst
                )}
                readOnly
              />
              <div className="d-flex justify-between my-1">
                <label>DCPS</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  value={
                    50000 < parseInt(calculatedValues.dcps)
                      ? parseInt(calculatedValues.dcps) - 50000
                      : 0
                  }
                />
              </div>
              {/* <FormInput
                label="DCPS"
                value={
                  50000 < calculatedValues.dcps
                    ? calculatedValues.dcps - 50000
                    : 0
                }
                readOnly
              /> */}
              <FormInput label="GIS" value={calculatedValues.gis} readOnly />

              <FormInput label="LIC" value={calculatedValues.lic} readOnly />

              {/* <FormInput
                label="Tution Fees"
                value={calculatedValues.tutionFees}
                onChange={(value) =>
                  handleCalculatedValueChange("tutionFees", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>Tution Fees</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.tutionFees}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "tutionFees",
                      value.target.value
                    )
                  }
                />
              </div>
              <div className="d-flex justify-between my-1">
                <label>NSC</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.nsc}
                  onChange={(value) =>
                    handleCalculatedValueChange("nsc", value.target.value)
                  }
                />
              </div>
              {/* <FormInput
                label="NSC"
                value={calculatedValues.nsc}
                onChange={(value) => handleCalculatedValueChange("nsc", value)}
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>PLI/RD</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.pliRd}
                  onChange={(value) =>
                    handleCalculatedValueChange("pliRd", value.target.value)
                  }
                />
              </div>
              {/* <FormInput
                label="PLI/RD"
                value={calculatedValues.pliRd}
                onChange={(value) =>
                  handleCalculatedValueChange("pliRd", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>Home Loan Principal</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.homeLoanPrincipal}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "homeLoanPrincipal",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="Home Loan Principal"
                value={calculatedValues.homeLoanPrincipal}
                onChange={(value) =>
                  handleCalculatedValueChange("homeLoanPrincipal", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>Mutual Fund</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.mutualFund}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "mutualFund",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="Mutual Fund"
                value={calculatedValues.mutualFund}
                onChange={(value) =>
                  handleCalculatedValueChange("mutualFund", value)
                }
                readOnly={false}
              /> */}
              <FormInput
                label="Total Deduction U/s 80-C"
                value={calculatedValues.totalDeduction80C}
                readOnly
              />
              <FormInput
                label={`Deduction U/s 80-C`}
                value={
                  calculatedValues.totalDeduction80C > 150000
                    ? 150000
                    : calculatedValues.totalDeduction80C
                }
                readOnly
              />
              {/* </FormSection> */}
            </div>

            <div className="bg-blue-50 p-3 rounded-lg mb-6 text-left">
              <h5 className="font-bold mb-3" style={{ fontSize: 18 }}>
                Deduction U/S VI-A
              </h5>
              {/* <FormSection title="Deduction U/S VI-A"> */}
              {/* <FormInput
                label="CCD 1B Additional Deducton to NPS"
                value={calculatedValues.ccd1b}
                onChange={(value) =>
                  handleCalculatedValueChange("ccd1b", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>CCD 1B Additional Deducton to NPS</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  // defaultValue={calculatedValues.ccd1b}
                  value={
                    50000 < parseInt(calculatedValues.dcps)
                      ? 50000
                      : parseInt(calculatedValues.dcps)
                  }
                  // onChange={(value) =>
                  //   handleCalculatedValueChange("ccd1b", value.target.value)
                  // }
                />
              </div>
              <FormInput
                label="CCD 2 Employer contribution (NPS)"
                value={calculatedValues.nps}
                // onChange={(value) => handleCalculatedValueChange("ccd2", value)}
                readOnly
              />
              {/* <FormInput
                label="U/S 80D Mediclaim Insurance"
                value={calculatedValues.mediclaim}
                onChange={(value) =>
                  handleCalculatedValueChange("mediclaim", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80D Mediclaim Insurance</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.mediclaim}
                  onChange={(value) =>
                    handleCalculatedValueChange("mediclaim", value.target.value)
                  }
                />
              </div>
              {/* <FormInput
                label="U/S 80DD Dependent Handicapped Person"
                value={calculatedValues.dependentHandicapped}
                onChange={(value) =>
                  handleCalculatedValueChange("dependentHandicapped", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80DD Dependent Handicapped Person</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.dependentHandicapped}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "dependentHandicapped",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="U/S 80E Interest on educational loan"
                value={calculatedValues.educationLoanInterest}
                onChange={(value) =>
                  handleCalculatedValueChange("educationLoanInterest", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80E Interest on educational loan</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.educationLoanInterest}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "educationLoanInterest",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="U/S 80EEB Electric Vehicle Loan"
                value={
                  Math.round(calculatedValues.electricVehicleLoan * 100) / 100
                }
                onChange={(value) =>
                  handleCalculatedValueChange("electricVehicleLoan", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80EEB Electric Vehicle Loan</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.electricVehicleLoan}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "electricVehicleLoan",
                      value.target.value
                    )
                  }
                />
              </div>
              {/* <FormInput
                label="U/S 80G Donation"
                value={Math.round(calculatedValues.donation * 100) / 100}
                onChange={(value) =>
                  handleCalculatedValueChange("donation", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80G Donation</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.donation}
                  onChange={(value) =>
                    handleCalculatedValueChange("donation", value.target.value)
                  }
                />
              </div>
              {/* <FormInput
                label="U/S 80U Self Handicapped Person"
                value={Math.round(calculatedValues.selfHandicapped * 100) / 100}
                onChange={(value) =>
                  handleCalculatedValueChange("selfHandicapped", value)
                }
                readOnly={false}
              /> */}
              <div className="d-flex justify-between my-1">
                <label>U/S 80U Self Handicapped Person</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-3 py-1 w-32 sm:w-32 text-right"
                  defaultValue={calculatedValues.selfHandicapped}
                  onChange={(value) =>
                    handleCalculatedValueChange(
                      "selfHandicapped",
                      value.target.value
                    )
                  }
                />
              </div>
              <FormInput
                label="Total Deduction U/S VI-A"
                value={Math.round(
                  50000 < parseInt(calculatedValues.dcps)
                    ? calculatedValues.totalDeductionVIA + 50000
                    : calculatedValues.totalDeductionVIA +
                        parseInt(calculatedValues.dcps)
                )}
                readOnly
              />
              {/* </FormSection> */}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 mb-5">
            <RegimeSection
              title="Old Regime"
              items={taxItems}
              taxableIncome={calculatedValues.oldRegimeTaxableIncome}
              tax={calculatedValues.oldRegimeTax}
            />

            <RegimeSection
              title="New Regime"
              items={taxItems}
              taxableIncome={calculatedValues.newRegimeTaxableIncome}
              tax={calculatedValues.newRegimeTax}
            />
            <div className=" mt-4">
              <div className="card p-3 mt-4">
                <div className="row">
                  <div className="col-lg-8">
                    <h4 className="fw-bold text-left">I have Accepted </h4>
                  </div>
                  <div className="col-lg-4">
                    <h4 className="fw-bold text-end text-danger">New Regime</h4>
                  </div>
                </div>
              </div>
              <div className="card p-3 mt-3">
                <div className="row">
                  <div className="col-lg-8">
                    <h4 className="fw-bold text-left">
                      Total Income Tax to Pay
                    </h4>
                  </div>
                  <div className="col-lg-4">
                    <h4 className="fw-bold text-end text-danger">
                      {Math.min(
                        oldRegimeData && oldRegimeData.total_it_payable,
                        newRegimeData && newRegimeData.total_it_payable
                      )}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card p-3 mt-3">
                <div className="row">
                  <div className="col-lg-8">
                    <h4 className="fw-bold text-left">
                      For the Financial Year
                    </h4>
                  </div>
                  <div className="col-lg-4">
                    <h4 className="fw-bold text-end text-danger">
                      {singleEmployee && singleEmployee.financialYear}
                    </h4>
                  </div>
                </div>
              </div>
              {/* Sub Section Ends */}
              <div className="mt-3">
                <div className="row">
                  <div className="col-lg-6 m-auto text-center ">
                    <button
                      onClick={() => storeITCData()}
                      className="bg-blue-500 w-100 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default IncometaxCalculation;
